module.exports = __webpack_public_path__ + "img/1.78e587a8.png";